import React from 'react'
import './categories.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

function MapCategories() {
  return (
    <div className='categories'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>Specification Categories</h2>
                    </div>
                    <p>Select the category related to the map</p>
                </div>
                <p className="nav-status">Home/Categories</p>
            </div> 
            <div className="all-categories">
                <Link to='/mapgazette/1'>
                    <div className="each">
                        <div className="h3">GENERAL CIVIL</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
                <Link to='/mapgazette/2'>
                    <div className="each">
                        <div className="h3">LANDS</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
                <Link to='/mapgazette/6'>
                    <div className="each">
                        <div className="h3">FAMILY AND PROBATE (DIVORCE, PURE PROBATE AND CUSTODY)</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
                <Link to='/mapgazette/14'>
                    <div className="each">
                        <div className="h3">BAIL APPLICATION</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link> 
                <Link to='/mapgazette/7'>
                    <div className="each">
                        <div className="h3">FUNDAMENTAL HUMAN RIGHT</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
                <Link to='/mapgazette/15'>
                    <div className="each">
                        <div className="h3">GRANTING LEAVE TO FILE DIVORCE</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
                <Link to='/mapgazette/16'>
                    <div className="each">
                        <div className="h3">JUDICIAL REVIEW</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
                <Link to='/mapgazette/3'>  
                    <div className="each">
                        <div className="h3">CRIMINAL</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
                <Link to='/mapgazette/4'>  
                    <div className="each">
                        <div className="h3">COMMERCIAL</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
                <Link to='/mapgazette/9'>  
                    <div className="each">
                        <div className="h3">MORTGAGES AND REVENUE</div>
                        <FontAwesomeIcon icon={faPlay} />
                        <div className="line-back"></div>
                    </div>
                </Link>
            </div>
        </div>
    </div>
  )
}

export default MapCategories